import { normalizeParam } from "@/lib/seo/canonical";
import type { ProseMirrorNode } from "./prosemirror-types";

export interface HeadingEntry {
  id: string;
  text: string;
}

export function readNumberAttr(
  attrs: Record<string, unknown> | undefined,
  key: string,
): number | undefined {
  const value = attrs?.[key];
  return typeof value === "number" ? value : undefined;
}

export function readStringAttr(
  attrs: Record<string, unknown> | undefined,
  key: string,
): string | undefined {
  const value = attrs?.[key];
  return typeof value === "string" ? value : undefined;
}

export function extractTextFromNode(node: ProseMirrorNode): string {
  if (node.text) return node.text;
  if (!node.content) return "";
  return node.content.map(extractTextFromNode).join("");
}

export function generateHeadingId(
  text: string,
  tracker: Map<string, number>,
): string {
  const base = normalizeParam(text) || "heading";
  const count = tracker.get(base) ?? 0;
  tracker.set(base, count + 1);
  return count === 0 ? base : `${base}-${count}`;
}
